export class AccessibilityElement extends Phaser.Events.EventEmitter {
  constructor(controller, container, ariaLabel, { x, y, width, height, scale }) {
    super();
    this._controller = controller;
    this._container = container;
    this._ariaLabel = ariaLabel;
    this._x = x;
    this._y = y;
    this._width = width;
    this._height = height;
    this._tabIndex = 1;
    this._scale = scale;
    this._createElement();
  }

  get element() {
    return this._element;
  }

  get x() {
    return this._x;
  }

  set x(value) {
    this._x = value;
    this._element.style.left = value * this._scale + 'px';
    this.emit('update');
  }

  get y() {
    return this._y;
  }

  set y(value) {
    this._y = value;
    this._element.style.top = value * this._scale + 'px';
    this.emit('update');
  }

  setPosition(x, y) {
    this.x = x;
    this.y = y;
  }

  get width() {
    return this._width;
  }

  set width(value) {
    this._width = value;
    this._element.style.width = value * this._scale + 'px';
    this.emit('update');
  }

  get height() {
    return this._height;
  }

  set height(value) {
    this._height = value;
    this._element.style.height = value * this._scale + 'px';
    this.emit('update');
  }

  get scale() {
    return this._scale;
  }

  set scale(value) {
    this._scale = value;
    this._element.style.top = this._y * this._scale + 'px';
    this._element.style.left = this._x * this._scale + 'px';
    this._element.style.width = this._width * this._scale + 'px';
    this._element.style.height = this._height * this._scale + 'px';
  }

  setSize(width, height) {
    this.width = width;
    this.height = height;
  }

  get ariaLabel() {
    return this._ariaLabel;
  }

  set ariaLabel(value) {
    this._ariaLabel = value;
    this._element.setAttribute('aria-label', this._ariaLabel);
  }

  focus() {
    this.emit('focus');
  }
  blur() {
    this.emit('blur');
  }
  select() {
    this.emit('select');
  }

  reindexElement() {
    this._removeElement();
    this._createElement();
  }

  _createElement() {
    if (this._element || !this._container) return;
    this._element = document.createElement('button');
    this._element.setAttribute('aria-label', this._ariaLabel);
    this._element.setAttribute('tabindex', 1);
    this._element.setAttribute('role', 'button');
    this._element.style.top = this._y * this._scale + 'px';
    this._element.style.left = this._x * this._scale + 'px';
    this._element.style.width = this._width * this._scale + 'px';
    this._element.style.height = this._height * this._scale + 'px';
    this._element.style.position = 'absolute';
    this._element.style.background = 'none';
    this._element.style.border = 'none';
    this._element.controller = this;
    this._container.appendChild(this._element);
  }

  _removeElement() {
    if (!this._element) return;
    this._container?.removeChild(this._element);
    this._element.controller = null;
    this._element = null;
  }

  destroy() {
    this._controller?.itemRemoved(this);
    this._removeElement();
    this._container = null;
    this._controller = null;
    super.destroy();
  }
}
